class Dropdown {
  constructor(dropdownConatiner, dropdownClass) {
    this.dropdownConatiner = document.querySelectorAll(dropdownConatiner);
    this.dropdownClass = dropdownClass;
  }

  toggleDropdown() {
    if (this.dropdownConatiner) {

      this.createDropDownButton();

      let dropdownButtons = document.querySelectorAll('.dropdown-button');

      dropdownButtons.forEach((el) => {

        el.addEventListener('click', (e) => {

          let currentClickButton = e.target;
          let dropDownChildren = currentClickButton.parentNode.querySelector('.children');

          dropDownChildren.classList.toggle(this.dropdownClass);
          dropDownChildren.classList.toggle('animated');
          dropDownChildren.classList.toggle('fadeIn');
        });
      })
    }
  }

  createDropDownButton() {
    this.dropdownConatiner.forEach((el) => {
      let createDropdownButton = document.createElement('button');
      let createDropdownLink = el.querySelector('a');

      createDropdownButton.classList.add('dropdown-button');

      insertAfter(createDropdownButton, createDropdownLink);
    })
  }

  initStateOpen() {
    let productCategories = document.querySelector('.product-categories');
    let productCategoriesItems = document.querySelectorAll('.current-cat');
    let productCategoriesItemsParent = document.querySelectorAll('.current-cat-parent');

    if(document.querySelectorAll('.current-cat').length>0 && document.querySelector('.current-cat-parent')){
        
      document.querySelector('.product-categories').prepend(document.querySelector('.current-cat-parent'));

    }
    else if(document.querySelectorAll('.current-cat').length>0){
        document.querySelector('.current-cat').classList.add('current-cat-parent');
    }

    if (productCategories) {
      if (productCategoriesItemsParent) {

        productCategoriesItemsParent.forEach(item => {

          let productCategoriesChild = item.querySelectorAll('.children');

          productCategoriesChild.forEach(childItems => {
            childItems.classList.add(this.dropdownClass, 'animated', 'fadeIn');
          });

          let productCategoriesChildP = item.querySelectorAll('.current-cat-parent');

          productCategoriesChildP.forEach(childItems => {
            let productCategoriesChild = childItems.querySelector('.children');

            productCategoriesChild.classList.add(this.dropdownClass, 'animated', 'fadeIn');
          });
        });
      }

      if (productCategoriesItems) {



        productCategoriesItems.forEach(item => {

          let productCategoriesChild = item.querySelectorAll('.children');

          productCategoriesChild.forEach(childItems => {
            childItems.classList.add(this.dropdownClass, 'animated', 'fadeIn');
          });

        });

      }

    }
  }
}


const insertAfter = (newNode, referenceNode) => {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};

export default Dropdown;



// WEBPACK FOOTER //
// ./scripts/modules/dropdown.js